import PersonDemographics from './PersonDemographics';

export default PersonDemographics;
